import React, { useState, useRef, useEffect } from 'react';
import { NavLink, useParams } from 'react-router-dom';
import axiosClient from "./axiosClient";
import { devlogAPIURL } from '../APIurl';
import Editor from './Editor';
import JoditEditor from "jodit-react";
import zIndex from '@mui/material/styles/zIndex';
import CryptoJs from 'crypto-js';

const FullPageView = (props) => {
    const [item, setItem] = useState();

    const { id } = useParams();
    useEffect(() => {
        (async function () {
            try {
                const res = await axiosClient.get(`${devlogAPIURL}/ankahiItem/${id}`);
                if (res.data) {
                    const genItems = JSON.parse(CryptoJs.AES.decrypt(res.data.johSamajhnaHoSamajhLe, process.env.REACT_APP_SECRET_KEY).toString(CryptoJs.enc.Utf8));
                    // genItems.commentArray=[{
                    //     text: 'comment text Lorem ipsum dolor sit amet consectetur adipisicing elit. Accusantium consectetur cum reiciendis incidunt nisi illo dolores eos mollitia nostrum error eius adipisci quo ad quos, nobis aliquam quidem nesciunt quam.',
                    //     by: 'username',
                    //     originalDate: 'today'
                    // }]
                    // console.log('genItem', genItems)
                    setItem(genItems);
                    setContent(genItems.body);
                }
            } catch (error) {
                return {
                    error
                };
            }
        })();
    }, []);

    const editor = useRef(null);
    const [content, setContent] = useState("...loading");
    const [comment, setComment] = useState("");
    const config = {
        readonly: true,
        height: 600,
        zIndex: 2,
    };
    const handleUpdate = (event) => {
        event.preventDefault();
        console.log('save', (content));
    };
    const handleComment = async () => {
        const putBody = {
            comment,
            originalDate: (new Date()).toISOString(),
        }
        setItem({
            ...item,
            commentsArray: item.commentsArray ? [...item.commentsArray, {
                ...putBody, postedBy: 'You', text: comment
            }]: [{
                ...putBody, postedBy: 'You', text: comment
            }]
        })
        const resp = await axiosClient.put(devlogAPIURL+'/ankahiItem/'+item._id+'/comment', {...putBody, comment: CryptoJs.AES.encrypt(putBody.comment, process.env.REACT_APP_SECRET_KEY).toString()});
        if(resp.status == 200) {
            // item.comm
        } else {
            alert('Kuch toh gadbad hai daya...');
        }
    }

    console.log('rendering');

    return (
        <div>
            <h2 className='text-center '>{item?.header}</h2>
            <p style={{textAlign: 'right', paddingRight: '20px'}}>{item? new Date(item.originalDate).toDateString(): ''}</p>
            <hr />
            <div className="App w-75 m-auto text-black">
                <JoditEditor
                    ref={editor}
                    value={content}
                    config={config}
                    onBlur={(newContent) => { setContent(newContent) }}
                />
            </div>
            <div className="w-75 mt-3 m-auto">
            <div> Comments </div>
            {
                item?.commentsArray?.length ? <>
                    {item.commentsArray.map((comment)=>{
                        return <>
                            <span className='d-flex  bg-lightgray text-black w-75 border-b-1'>
                            <h5>{comment.postedBy}</h5>
                            <h6 className='pl-3'>{(new Date(comment.created).toDateString())} {(new Date(comment.created).toLocaleTimeString())}</h6>
                            </span>
                            <p className='w-75 mb-3 bg-white wrap-comment text-wrap text-black p-1' readOnly >
                                    {comment.text?.split("\n").map((i)=>{
                                        return <> {i} <br/>
                                        </>
                                    })}
                                 </p>
                        </>
                    })}
                </> : <>
                </>
            }
            <textarea class=" form-control" id="exampleFormControlTextarea1" rows="3" onChange={(event) => setComment(event.target.value)} ></textarea>
            <button type="button" class="btn btn-dark button-filled mt-1" onClick={handleComment}>Comment</button>

            </div>

        </div>
    );
}

export default FullPageView;

